var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.751,
    height: 26.258,
    viewBox: "0 0 19.751 26.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.62 -4.543)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.72 4.643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9,16.095h1.368V10.5H21.313l2.023-3.471h1.805V8.779h4.136v-1.4h-.646v.756H25.787V5.289h2.845v.688h.646V4.643H25.142V6.388H22.965l-2.4,4.117H18.733v5.59h9.016v5.018a8.052,8.052,0,0,0-11.09,5.55H14.72V30.7H34.271V26.662H32.38a8,8,0,0,0-1.218-2.738H32.9v-7.83Zm-13.524-.646v-4.3H33.625v4.3H32.9V13.535H27.749v1.914ZM33.625,27.308v2.747H15.366V27.308Zm-1.91-.646H17.323a7.427,7.427,0,0,1,14.392,0Zm.542-3.384h-1.59a8.162,8.162,0,0,0-2.273-1.848V14.181h3.862v9.1Z",
    transform: "translate(-14.72 -4.643)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.345,
    height: 0.646,
    transform: "translate(5.79 7.388)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.345,
    height: 0.646,
    transform: "translate(5.79 8.892)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.c1337877.svg";
export { ForwardRef as ReactComponent };